import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=ac49e962&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=ac49e962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac49e962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac49e962')) {
      api.createRecord('ac49e962', component.options)
    } else {
      api.reload('ac49e962', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=ac49e962&scoped=true&", function () {
      api.rerender('ac49e962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20PG6paUVJ6g1/JS/comp/DocBox.vue"
export default component.exports